import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

// Components

import "./css/Accordion.scss";

// Icons

import Chevron from "./Chevron";
import { Download } from "react-feather";

const Accordion = (props) => {
  console.log(props.content);
  const [isActive, setActive] = useState(false);
  const [height, setHeight] = useState(0);

  function toggleAccordion() {
    setActive(!isActive);
    setHeight(!isActive ? "10vh" : 0);
  }

  const AccordionVariant = {
    inactive: {
      opacity: 0,
      height: 0,
      padding: "0% 2.5%",
      translateY: 10,
      backgroundColor: "var(--l-grey)",
      color: "var(--white)",
      transition: {
        ease: [0.6, 0.01, -0.05, 0.95],
        duration: 0.6,
        delay: 0,
      },
    },
    active: {
      height: "10vh",
      translateY: 0,
      opacity: 1,
      padding: "0% 2.5%",
      backgroundColor: "#0985f233",
      color: "var(--secondary)",
      transition: {
        ease: [0.6, 0.01, -0.05, 0.95],
        duration: 0.6,
        delay: 0,
      },
    },
  };

  return (
    <div className="accordion-section">
      <button
        className={`accordion ${isActive ? "active" : ""}`}
        onClick={toggleAccordion}
      >
        {props.title ? <p>{props.title}</p> : <p>{props.name}</p>}
        <Chevron width={25} height={25} active={isActive} />
      </button>
      {isActive && (
        <motion.div
          className={`accordion-content ${
            typeof props.content === "object" ? "reports" : ""
          }`}
          variants={AccordionVariant}
          initial="inactive"
          animate={isActive ? "active" : "inactive"}
        >
          {typeof props.content === "object" && (
            <>
              {props.content.map((fileDetails, index) => {
                return (
                  <div className="row" key={index}>
                    <div className="row-title">
                      <div className="link">{fileDetails.name}</div>
                    </div>
                    <Link to={fileDetails.file} target="_blank" download>
                      <div className="row-text">
                        <Download />
                      </div>
                    </Link>
                  </div>
                );
              })}
            </>
          )}
          {typeof props.content === "string" && (
            <>
              <div className="accordion-text" style={{ width: "100%" }}>
                {props.content}
              </div>
            </>
          )}
        </motion.div>
      )}
    </div>
  );
};

export default Accordion;
